import * as React from 'react'
import { ReactElement } from 'react'
import TravelList from '../../../components/List/Travel/TravelList'
import { TravelOverviewDto } from '../../../config/registrationConfig'
import { RegistrationListProps } from '../../../components/List/Registration/RegistrationList'

export default function TravelOverview(props: RegistrationListProps<TravelOverviewDto>): ReactElement {
    return <TravelList {...props} />
}
